let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("djSOz")).then(() => parcelRequire('3vm3R'));